import React from "react";
import "./Button.css";

/**
 * Brand button — the canonical action control, surface-aware via semantic
 * tokens. Replaces ad-hoc MUI Button usage.
 *
 * Props:
 *   variant: "primary" | "secondary" | "ghost" | "danger"   (default "primary")
 *   size:    "sm" | "md" | "lg"                              (default "md")
 *   startIcon, endIcon: nodes
 *   loading: bool — shows a spinner, disables interaction
 *   fullWidth: bool
 *   as: element/component (e.g. "a" or RouterLink)
 *   ...rest spreads onto the element (onClick, href, type, disabled, …)
 */
const Button = ({
  variant = "primary",
  size = "md",
  startIcon,
  endIcon,
  loading = false,
  fullWidth = false,
  as: Tag = "button",
  className = "",
  disabled,
  children,
  ...rest
}) => (
  <Tag
    className={`gx-btn gx-btn--${variant} gx-btn--${size} ${fullWidth ? "is-full" : ""} ${loading ? "is-loading" : ""} ${className}`}
    disabled={Tag === "button" ? disabled || loading : undefined}
    aria-busy={loading || undefined}
    {...rest}
  >
    {loading && <span className="gx-btn-spinner" aria-hidden="true" />}
    {startIcon && <span className="gx-btn-icon">{startIcon}</span>}
    {children && <span className="gx-btn-label">{children}</span>}
    {endIcon && <span className="gx-btn-icon">{endIcon}</span>}
  </Tag>
);

export default Button;
